import React from 'react';

import utils from './MoleculeCard/MoleculeCardUtils';
import Masonry from 'react-masonry-component';
import MoleculeCard from './MoleculeCard/MoleculeCard';
import { WindowResizeListener } from 'react-window-resize-listener';


export default class MasonryFeed extends React.Component {

  constructor() {
    const { localStorage } = window;
    super();
    this.state = {
      // background: 'red',
      cardMargin: 10,
      cardWidth: 240,
      cardHeight: parseInt(localStorage.getItem('cardHeight'), 10),
    };
  }

  calcWidth(windowSize, cardWidth, cardMargin) {
    const s = cardWidth + cardMargin * 2;
    return Math.floor(((windowSize && windowSize.windowWidth) || 0) / s) * s;
  }

  moleculeLayout(molecule) {
    const selected = this.props.selected || [];
    const isSelected = selected.indexOf(molecule) !== -1;
    if (isSelected && selected.length > 1) {
      return 'selected';
    } else if (isSelected) {
      return 'selected';
    } else {
      return 'inactive';
    }
  }

  render() {
    const { molecules, actions } = this.props;
    const { windowSize, cardWidth, cardMargin, cardHeight } = this.state;
    const convasWidth = this.calcWidth(windowSize, cardWidth, cardMargin);
    let dashStyle = {
      margin: 0,
      padding: 0,
    };
    if (this.state.background) {
      dashStyle.background = this.state.background;
    }
    return (
      <div>
        <WindowResizeListener onResize={wSize => {
          this.setState({...this.state, windowSize: wSize});
        }}/>
        <div style={{
          margin: '0 auto',
          width: convasWidth,
        }}>
          <Masonry
            style={dashStyle}
            options={{
              transitionDuration: 100,
              enableResizableChildren: true,
            }}
          >
          {molecules.map((molecule, index) => {
            return (
              <MoleculeCard
                key={molecule.fp}
                cardHeight={cardHeight}
                cardWidth={cardWidth}
                cardMargin={cardMargin}
                molecule={molecule}
                actions={actions}
                layout={this.moleculeLayout(molecule)}
                onAction={action => {
                  const { onAction } = this.props;
                  const hyphen = utils.hyphenToCamel('on-' + action.name);
                  const handler = this.props[hyphen];
                  if (handler) {
                    handler(action);
                  }
                  if (onAction) {
                    onAction(action);
                  }
                }}
              />
            );
          })}
          </Masonry>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/MasonryFeed.jsx